import 'reflect-metadata';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { unregister } from './registerServiceWorker';
import './i18n';
import './styles/app.css';
import './styles/index.css';
import './styles/modal.css';
import './polyfill.js';

const appRoot = document.getElementById('root');
ReactDOM.render(<App />, appRoot);
//registerServiceWorker();

unregister();
